export default {
  inova: {
    primary: '#f58236',
    contrast: 'white',
  },
  tosalvo: {
    primary: '#17a2b8',
    contrast: 'white',
  },
}
